const areas = [
  { name: "Brandon", desc: "Growing suburb east of Sioux Falls along I-90, Minnehaha County" },
  { name: "Harrisburg", desc: "Fastest-growing city in SD, Lincoln County south of Sioux Falls" },
  { name: "Tea", desc: "Residential community off I-29 southwest of Sioux Falls" },
  { name: "Hartford", desc: "West of Sioux Falls along I-90 in Minnehaha County" },
  { name: "Lennox", desc: "Lincoln County community south of Sioux Falls near I-29" },
  { name: "Garretson", desc: "Split Rock Creek community northeast of Sioux Falls" },
  { name: "Dell Rapids", desc: "Small city along the Big Sioux River, Minnehaha County" },
  { name: "Worthing", desc: "Lincoln County community close to the Nebraska border" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Sioux Falls and All of Minnehaha &amp; Lincoln County
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              The nearest passport agency to Sioux Falls is in Minneapolis, over 270 miles away via I-90. Fast Passport Center eliminates that trip entirely — serving all of the Sioux Empire region with registered courier delivery to the agency.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Whether you are in downtown Sioux Falls, the western suburbs near Falls Park, or a surrounding community in Minnehaha or Lincoln County, we handle your passport from door to door.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {areas.map((area, i) => (
                <div key={i} className="flex items-start gap-2.5 bg-[#F7F8FA] rounded-lg p-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#F6C344] text-base"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A365D] text-sm">{area.name}</p>
                    <p className="text-gray-400 text-xs leading-snug">{area.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-lg overflow-hidden border border-gray-200 h-[420px]">
            <iframe
              title="Sioux Falls South Dakota Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91840.47707157655!2d-96.84070!3d43.54972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x878eb1b433a6f1c1%3A0x5f6e7e2e7b8c1a2a!2sSioux+Falls%2C+SD!5e0!3m2!1sen!2sus!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}